module.exports = __webpack_public_path__ + "assets/img/0804.44cd0ee0.png";